import { CalloutBlock } from "@bezoned/shared/components/callout-block.jsx";

export const RetryPermissionPropagation = ({
  onRetry,
}: {
  onRetry: () => void;
}) => (
  <div className="flex min-h-screen items-center justify-center bg-gray-100">
    <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
      <h1 className="mb-4 text-2xl font-bold text-gray-900">
        Permissions Propagating
      </h1>

      <CalloutBlock variant="info">
        <p>
          It seems that Microsoft has not yet propagated the permissions. We
          need to wait a bit, before we can create your organization in BeZoned.
        </p>
        <p>
          Please try running the check again. If the issue persists, please
          contact our support team.
        </p>
      </CalloutBlock>

      <button
        className="bg-bzd-button hover:bg-bzd-button-hover mt-4 w-full rounded-md px-4 py-2 text-white transition-colors"
        onClick={onRetry}
        type="button"
      >
        Check again
      </button>
    </div>
  </div>
);
